module.exports = __webpack_public_path__ + "img/SINGLE EAR RING LIME.a8be7a2.svg";